const VIEW = "view";

export { VIEW };
